<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const translateY = ref(props.innerText.length * 26 + 65);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="40" viewBox="0 0 1024 39">
  <defs>
    <linearGradient id="linear-gradient" x1="1" y1="1.093" x2="-0.177" y2="-0.36" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="#fff"/>
      <stop offset="0.172" stop-color="#fff"/>
      <stop offset="1" stop-color="var(--theme-color-1)"/>
    </linearGradient>
  </defs>
  <g id="xiaobiao7" transform="translate(0 -5)">
    <g id="组_4862" data-name="组 4862">
      <path id="联合_171" data-name="联合 171" d="M14718,3780.5a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14718,3780.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14710,3780.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14702,3780.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14694,3780.5Zm24-8a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14718,3772.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14710,3772.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14702,3772.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14694,3772.5Zm24-8a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14718,3764.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14710,3764.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14702,3764.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14694,3764.5Zm24-8a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14718,3756.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14710,3756.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14702,3756.5Zm-8,0a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,14694,3756.5Z" transform="translate(-14694.002 -3749)" fill="url(#linear-gradient)"/>
      <path id="联合_172" data-name="联合 172" d="M24,26.5A2.5,2.5,0,1,1,26.5,29,2.5,2.5,0,0,1,24,26.5Zm-8,0A2.5,2.5,0,1,1,18.5,29,2.5,2.5,0,0,1,16,26.5Zm-8,0A2.5,2.5,0,1,1,10.5,29,2.5,2.5,0,0,1,8,26.5Zm-8,0A2.5,2.5,0,1,1,2.5,29,2.5,2.5,0,0,1,0,26.5Zm24-8A2.5,2.5,0,1,1,26.5,21,2.5,2.5,0,0,1,24,18.5Zm-8,0A2.5,2.5,0,1,1,18.5,21,2.5,2.5,0,0,1,16,18.5Zm-8,0A2.5,2.5,0,1,1,10.5,21,2.5,2.5,0,0,1,8,18.5Zm-8,0A2.5,2.5,0,1,1,2.5,21,2.5,2.5,0,0,1,0,18.5Zm24-8A2.5,2.5,0,1,1,26.5,13,2.5,2.5,0,0,1,24,10.5Zm-8,0A2.5,2.5,0,1,1,18.5,13,2.5,2.5,0,0,1,16,10.5Zm-8,0A2.5,2.5,0,1,1,10.5,13,2.5,2.5,0,0,1,8,10.5Zm-8,0A2.5,2.5,0,1,1,2.5,13,2.5,2.5,0,0,1,0,10.5Zm24-8A2.5,2.5,0,1,1,26.5,5,2.5,2.5,0,0,1,24,2.5Zm-8,0A2.5,2.5,0,1,1,18.5,5,2.5,2.5,0,0,1,16,2.5Zm-8,0A2.5,2.5,0,1,1,10.5,5,2.5,2.5,0,0,1,8,2.5Zm-8,0A2.5,2.5,0,1,1,2.5,5,2.5,2.5,0,0,1,0,2.5Z" transform="translate(${translateY.value} 43.002) rotate(180)" fill="url(#linear-gradient)"/>
    </g>
    <text id="项目执行人性别分布" transform="translate(25.998 37)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
